import React from 'react'
import './reject.styles.scss'
import Worker from './worker'
import Loading from '../../../../components/loading/loading.component'
import Dialog from '../../../../components/dialog/dialog.component'
import { withRouter } from 'react-router-dom'

class RejectDialog extends React.Component {

    constructor(props) {
        super(props)
        this.worker = Worker(this)
        this.state = this.worker.getDefaultState()
    }

    componentDidMount(){
        this.worker.rejectManuscript()
    }

    render() {
        return (
            <Dialog>
                <div className="reject card">
                    <div className="header">
                        <h4>Reject Manuscript</h4>
                    </div>
                    <div className={"flag " + this.state.flag.type}>
                        {this.state.flag.text}
                    </div>
                    {this.state.processing ? <Loading /> : <></>}
                </div>
            </Dialog>
        )
    }
}

export default withRouter(RejectDialog)